import {AdminEntityService} from "../admin/AdminEntityService";
import {
    AchievementsConstraints,
    AchievementConfig,
    ListAchievementsResponse, UserAchievementInfo, OperatorProgression
} from "../../../generated/protocol";
import {AbstractAdminEntityService} from "../admin/AbstractAdminEntityService";
import {injectable} from "inversify";


export interface AchievementsService extends AdminEntityService<AchievementConfig> {
    getConstraints(): Promise<AchievementsConstraints>;

    getUserAchievementInfo(userId: string, operatorId: number): Promise<UserAchievementInfo>;

    deleteUserItem(userId: string, itemId: string): Promise<{}>;

    disableAchievement(nameId: string, operatorId: number): Promise<OperatorProgression>;

    enableAchievement(nameId: string, operatorId: number): Promise<OperatorProgression>;
}

@injectable()
export class AchievementsServiceImpl extends AbstractAdminEntityService<AchievementConfig, ListAchievementsResponse> implements AchievementsService {


    constructor() {
        super("/achievements");
    }

    getConstraints(): Promise<AchievementsConstraints> {
        return this.http.doGet(this.entityPath + "/constraints");
    }

    getUserAchievementInfo(userId: string, operatorId: number): Promise<UserAchievementInfo> {
        return this.http.doGet(this.entityPath + "/user/" + userId + "/" + operatorId);
    }

    deleteUserItem(userId: string, itemId: string): Promise<{}> {
        return this.http.doDelete(`${this.entityPath}/user/${userId}/item/${itemId}`);
    }

    disableAchievement(nameId: string, operatorId: number): Promise<OperatorProgression> {
        return this.http.doGet(this.entityPath + "/toggle/" + nameId + "/" + operatorId + "/false");
    }

    enableAchievement(nameId: string, operatorId: number): Promise<OperatorProgression> {
        return this.http.doGet(this.entityPath + "/toggle/" + nameId + "/" + operatorId + "/true");
    }
}


// WEBPACK FOOTER //
// ./src/app/service/achievements/AchievementsService.ts